import {languageList, languageKeys} from '../../config';
/*
|--------------------------------------------------------------------------
| Initial State
|--------------------------------------------------------------------------
*/
const initialState = {
    lang: 'ja',
};

/*
|--------------------------------------------------------------------------
| Mutations
|--------------------------------------------------------------------------
*/
const mutations = {
  setLanguage (state, lang) {
    if(lang && lang == 'jp') {
      state.lang = 'ja'
    } else {
      state.lang = lang
    }
  },
  unsetLanguage(state) {
    state.lang = 'en';
  },
};

/*
|--------------------------------------------------------------------------
| Actions
|--------------------------------------------------------------------------
*/
const actions = {
  selectLanguage ({ commit }, lang) {
    commit('setLanguage', lang)
  },
  unsetLanguage: (context) => {
    context.commit('unsetLanguage')
  },
};

/*
|--------------------------------------------------------------------------
| Getters
|--------------------------------------------------------------------------
*/
const getters = {
  selectedLanguage: state => {
    let slang = (state.lang == 'jp') ? 'ja' : state.lang;
    if(languageList[slang] === undefined) slang = 'en';
    return {
      key: slang,
      native: languageList ? languageList[slang].native : '',
      en: languageList ? languageList[slang].en : '' ,
      ja: languageList ? languageList[slang].ja : ''
    }
  },
};

/*
|--------------------------------------------------------------------------
| Export the module
|--------------------------------------------------------------------------
*/
export default {
  state: initialState,
  mutations,
  actions,
  getters
}
